/* global $ I18n */
$(document).on('ready turbolinks:load', () => {
  $('.multi-item').each((index, item) => {
    const $this = $(item);
    const values = $this.data('values');
    const name = $this.data('name');
    const currentValue = $this.data('current-value');
    const placeHolder = $this.data('placeholder');
    const maxSize = $this.data('max-size');

    if (values !== undefined && name !== undefined) {
      $this.removeData('values');
      const ms = $this.magicSuggest({
        placeholder: placeHolder,
        data: values,
        toggleOnClick: true,
        hideTrigger: true,
        allowFreeEntries: false,
        name,
        value: currentValue,
        maxSelection: maxSize || 10,
        noSuggestionText: I18n.t('ui.extras.suggestion.no_suggestion'),
      });

      // when the selection change, trigger a 'change' event
      // the hidden input managed by magicSuggest is buggy and can't trigger the 'change' event
      // find the first input with refresh form url and trigger the 'change' event from there
      const triggerChange = $this.data('trigger-change');
      if (triggerChange !== undefined) {
        $(ms).on('selectionchange', () => {
          $('[data-refresh-form-url]').first().trigger('change');
        });
      }
    }
  });

  $('.single-item').each((index, item) => {
    const $this = $(item);
    const values = $this.data('values');
    const name = $this.data('name');
    const currentValue = $this.data('current-value');
    const placeHolder = $this.data('placeholder');

    if (values !== undefined && name !== undefined) {
      $this.removeData('values');
      const params = {
        placeholder: placeHolder,
        data: values,
        toggleOnClick: true,
        hideTrigger: true,
        allowFreeEntries: false,
        maxSelection: 1,
        name,
        maxSelectionRenderer: () => I18n.t('extras.suggestion.limit_one'),
        noSuggestionText: I18n.t('extras.suggestion.no_suggestion'),
      };

      if (currentValue !== undefined && currentValue !== '') {
        params.value = [currentValue];
      }

      $this.magicSuggest(params);
    }
  });
});
